import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, IconButton, Collapse, Box, Typography, Paper, Switch } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import esArray from './functionEsArray';

export const RestriccionesPorPerfil = (data) => {
  const { menu, roles_menu, id_roles, setDatosInsert ,roles_menu_funcionalidad } = data;
  console.log("data", data);
  // Datos originales
  const originalData = menu;

    /**
   * Convierte los datos originales en una estructura jerárquica
   * de módulos y submódulos, incluyendo funcionalidades asociadas.
   */
  const modules = originalData.reduce((acc, { id, level, name, module, relations }) => {
    const [moduleLevel] = level.split('.');
    const submoduleName = name.trim();
    const submodule = {
      id,
      level,
      name: submoduleName,
      funcionalidades: relations?.funcionalidades ? esArray(relations.funcionalidades) : [],
    };

    let moduleIndex = acc.findIndex((mod) => mod.level === moduleLevel);
    if (moduleIndex === -1) {
      acc.push({
        id: id,
        level: moduleLevel,
        name: module,
        submodules: [submodule],
        nivel: level,
        funcionalidades: relations?.funcionalidades ? esArray(relations.funcionalidades) : [],
      });
    } else {
      acc[moduleIndex].submodules.push(submodule);
    }

    return acc;
  }, []);

    /**
   * Ajusta los submódulos, agrupando aquellos cuyo nivel termina en "00.00"
   * e incluyendo los elementos relacionados en su interior.
   */
  const adjustSubmodules = (modules) => {
    return modules.map((module) => {
      const filteredSubmodules = module.submodules.filter(submodule => submodule.level.endsWith("00.00"));
      const updatedSubmodules = filteredSubmodules.map((submodule) => {
        const nivelSubModulo = submodule.level.split('.').slice(0, 2).join('.');
        return {
          ...submodule,
          items: module.submodules.filter(item => item.level !== submodule.level && item.level.split('.').slice(0, 2).join('.') === nivelSubModulo),
        };
      });
      return {
        ...module,
        submodules: updatedSubmodules,
      };
    });
  };

   /**
   * Inicializa el estado de los switches para módulos y submódulos
   * basándose en los datos del menú y roles.
   */
   const switchItemsInicial = (modules, rolesMenu, rolesMenuFuncionalidad) => {
    const result = {};

    // Mapea roles del menú para acceso rápido por id
    const menuRolesMap = new Map(
      rolesMenu.map(role => [role.id_menu, { id_menu_acciones_tipo: role.id_menu_acciones_tipo, id: role.id }])
    );

    // Agrupa funcionalidades por id del menú
    const funcionalidadesPorMenu = rolesMenuFuncionalidad.reduce((acc, item) => {
      if (!acc[item.id_menu]) {
        acc[item.id_menu] = {};
      }
      acc[item.id_menu][`${item.id_funcionalidad}`] = item.activo === "1";
      return acc;
    }, {});
  
    modules.forEach((module) => {
      module.submodules.forEach((submodule) => {
        const { level, id } = submodule;
        const nivelParts = level.split('.');
        
        const menuData = menuRolesMap.get(id);
        const funcionalidades = funcionalidadesPorMenu[id] || {};
        const isActive = !menuData || parseInt(menuData.id_menu_acciones_tipo) === 1;
  
        if (level.endsWith("00.00")) {
          if (!result[level]) {
            result[level] = {
              activo: isActive,
              id_menu: id,
              id_roles: id_roles,
              id: menuData ? menuData.id : null,
              items: {},
              ...funcionalidades // Mezcla funcionalidades
            };
          }
        } else {
          const parentLevel = nivelParts.slice(0, 2).join('.') + ".00.00";
  
          if (!result[parentLevel]) {
            result[parentLevel] = {
              activo: true,
              items: {},
              id_menu: id,
              id_roles: id_roles,
              id: menuData ? menuData.id : null,
              ...funcionalidades
            };
          }
  
          result[parentLevel].items[level] = {
            activo: isActive,
            id_menu: id,
            id_roles: id_roles,
            id: menuData ? menuData.id : null,
            ...funcionalidades
          };
        }
      });
    });
  
    return result;
  };
  

  // Ajustar submódulos
  const modulos_ajustados = adjustSubmodules(modules);
  const [openSubmodules, setOpenSubmodules] = useState({});
  const [switchStates, setSwitchStates] = useState(switchItemsInicial(modules, roles_menu,esArray(roles_menu_funcionalidad)) || {});

  // Funciones para manejar los switches
  const toggleSubmodule = (level) => {
    setOpenSubmodules((prevState) => ({
      ...prevState,
      [level]: !prevState[level],
    }));
  };

 /**
   * Maneja el cambio de estado de un switch para un ítem.
   */
  const handleSwitchChange = (level, switchType) => {
    setSwitchStates((prevState) => {
      const currentSubmoduleState = prevState[level] || {};
      const isActive = !currentSubmoduleState[switchType];

      // Desactivar todos los ítems si el switch es 'activo' y se está desactivando
      const updatedItems = isActive
        ? currentSubmoduleState.items
        : Object.keys(currentSubmoduleState.items || {}).reduce((acc, itemLevel) => {
          acc[itemLevel] = {
            ...currentSubmoduleState.items[itemLevel],
            activo: false,  // Establecer 'activo' como falso para cada ítem
          };
          return acc;
        }, {});

      return {
        ...prevState,
        [level]: {
          ...currentSubmoduleState,
          [switchType]: isActive,
          items: updatedItems,
        },
      };
    });
  };

  // Función para manejar los switches de los ítems
  const handleItemSwitchChange = (submoduleLevel, itemLevel, switchType) => {
    setSwitchStates((prevState) => {
      const currentSubmoduleState = prevState[submoduleLevel] || {};
      const currentItemsState = currentSubmoduleState.items || {};
      const currentItemState = currentItemsState[itemLevel] || {};

      return {
        ...prevState,
        [submoduleLevel]: {
          ...currentSubmoduleState,
          items: {
            ...currentItemsState,
            [itemLevel]: {
              ...currentItemState,
              [switchType]: !currentItemState[switchType],
            },
          },
        },
      };
    });
  };

  useEffect(() => {

    setDatosInsert(switchStates);
  }, [setDatosInsert, switchStates]); // No need to include setDatosInsert

  // Renderizar la tabla
  return (
    <div>
      {modulos_ajustados
        .filter(module => module.name.trim() !== "") // Filtra los módulos cuyo nombre no esté vacío
        .map((module) => (
          <div key={module.level}>
            <h3>{module.name}</h3>
            <Paper>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Items</TableCell>
                    <TableCell>Submódulo</TableCell>
                    <TableCell>Activo</TableCell>
                    <TableCell>Solo Lectura</TableCell>
                    <TableCell>Todas Activadas</TableCell>
                    <TableCell>Personalizada</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {module.submodules.map((submodule) => (
                    <React.Fragment key={submodule.level}>
                      <TableRow>
                        <TableCell>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => toggleSubmodule(submodule.level)}
                          >
                            {openSubmodules[submodule.level] ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        </TableCell>
                        <TableCell>{submodule.name}</TableCell>
                        <TableCell>
                          <Switch
                            checked={switchStates[submodule.level]?.['activo'] || false}
                            onChange={() => handleSwitchChange(submodule.level, 'activo')}
                          />
                        </TableCell>
                        <TableCell>
                          <Switch
                            checked={switchStates[submodule.level]?.['soloLectura'] || false}
                            onChange={() => handleSwitchChange(submodule.level, 'soloLectura')}
                          />
                        </TableCell>
                        <TableCell>
                          <Switch
                            checked={switchStates[submodule.level]?.['todasActivadas'] || false}
                            onChange={() => handleSwitchChange(submodule.level, 'todasActivadas')}
                          />
                        </TableCell>
                        <TableCell>
                          <Switch
                            checked={switchStates[submodule.level]?.['personalizada'] || false}
                            onChange={() => handleSwitchChange(submodule.level, 'personalizada')}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
                          <Collapse in={openSubmodules[submodule.level]} timeout="auto" unmountOnExit>
                            <Box sx={{ alignItems: 'center', textAlign: 'center', margin: 'auto' }}>
                              <Typography variant="h6" gutterBottom component="div">
                                Items de {submodule.name}
                              </Typography>
                              <Table size="small" aria-label="items">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Item</TableCell>
                                    <TableCell>Activo</TableCell>
                                    {submodule.funcionalidades.map((func) => (
                                      <TableCell key={func.id}>{func.descripcion}</TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {submodule.items.map((item) => (
                                    <TableRow key={item.level}>
                                      <TableCell>{item.name}</TableCell>
                                      <TableCell>
                                        <Switch
                                          checked={switchStates[submodule.level]?.items?.[item.level]?.['activo'] || false}
                                          onChange={() => handleItemSwitchChange(submodule.level, item.level, 'activo')}
                                        />
                                      </TableCell>
                                      {submodule.funcionalidades.map((func) => (
                                        <TableCell key={func.id}> {/* Usar `id` como clave única */}
                                          <Switch
                                            checked={
                                              switchStates[submodule.level]?.items?.[item.level]?.[func.id] || false
                                            }
                                            onChange={() =>
                                              handleItemSwitchChange(submodule.level, item.level, func.id)
                                            }
                                          />
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </div>
        ))}
    </div>
  );
};

export default RestriccionesPorPerfil;
